import initHelpHero from 'helphero';
import isEmpty from 'lodash/isEmpty';

class Tour {
  constructor(appId) {
    this.tour = initHelpHero(appId);
    this.user = {};
  }

  available() {
    return this.hasUser();
  }

  initUser(user = {}) {
    const { firstName, withTour = false } = user;
    if (!withTour) return;
    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging') return;

    // set user and its name prop
    this.user = { ...user };
    this.setUserProp('name', firstName);
    console.log('Running onboarding');
  }

  hasUser() {
    return !isEmpty(this.user);
  }

  setUserProp(key = '', value = false) {
    if (isEmpty(key) || !this.available()) {
      return false;
    }

    const { id: userId } = this.user;
    this.tour.identify(userId, { [key]: value });
  }

  getTour() {
    return this.tour;
  }
}

const tour = new Tour('fzvW7cSeNty');
export default tour;
